import { forEach, classListToggle } from './lib/util';

export function bindCapsLockEvents() {
   // capslock indicator
   forEach(document.querySelectorAll('.mui-textfield.cuda-mui-textfield'), group => {
      forEach(group.querySelectorAll('input[type=password]'), field => {
         forEach(
            [
               ['keydown', true],
               ['keyup', false],
            ],
            ([eventName, warningVisible]) => {
               field.addEventListener(eventName, event => {
                  // standard || IE11
                  if (event.code === 'CapsLock' || event.keyCode === 'CapsLock') {
                     classListToggle(group, { 'cuda-capslock-warning': warningVisible });
                  }

                  // fallback for every key in case caps lock was pressed before form was focused
                  classListToggle(group, {
                     'cuda-capslock-warning': event.getModifierState('CapsLock'),
                  });
               });
            }
         );
      });
   });
}
